/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Footer_BlurbInputs */

const en_portal_footer_blurb = /** @type {(inputs: Portal_Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app for people who train: bookings, your plan and your progress from your coach, in one place.`)
};

const pl_portal_footer_blurb = /** @type {(inputs: Portal_Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja dla osób, które trenują: rezerwacje, plan i postępy od Twojego trenera w jednym miejscu.`)
};

/**
* | output |
* | --- |
* | "The app for people who train: bookings, your plan and your progress from your coach, in one place." |
*
* @param {Portal_Footer_BlurbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_footer_blurb = /** @type {((inputs?: Portal_Footer_BlurbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Footer_BlurbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_footer_blurb(inputs)
	return en_portal_footer_blurb(inputs)
});